import type {
  NetWorthResponse,
  AccountSuggestion,
  AccountBalance,
  AccountItem,
  BankConfigAccountHint,
  CreateCheckpointRequest,
  CreateAccountRequest,
  UpdateAccountRequest,
} from "@boo/shared";
import { request } from "./apiClient";

export async function fetchAccounts(): Promise<AccountItem[]> {
  return request<AccountItem[]>("/accounts");
}

export async function createAccount(
  payload: CreateAccountRequest,
): Promise<AccountItem> {
  return request<AccountItem>("/accounts", { method: "POST", data: payload });
}

export async function updateAccount(
  id: string,
  payload: UpdateAccountRequest,
): Promise<AccountItem> {
  return request<AccountItem>(`/accounts/${id}`, {
    method: "PATCH",
    data: payload,
  });
}

export async function deleteAccount(id: string): Promise<void> {
  await request<void>(`/accounts/${id}`, { method: "DELETE" });
}

export async function fetchBalances(): Promise<AccountBalance[]> {
  return request<AccountBalance[]>("/accounts/balances");
}

export async function addCheckpoint(
  id: string,
  payload: CreateCheckpointRequest,
): Promise<void> {
  await request<void>(`/accounts/${id}/checkpoints`, {
    method: "POST",
    data: payload,
  });
}

export async function fetchBankConfigHints(): Promise<BankConfigAccountHint[]> {
  return request<BankConfigAccountHint[]>("/accounts/bank-config-hints");
}

export async function backfillAccounts(): Promise<{ assigned: number }> {
  return request<{ assigned: number }>("/accounts/backfill", {
    method: "POST",
  });
}

export async function fetchAccountSuggestions(): Promise<AccountSuggestion[]> {
  return request<AccountSuggestion[]>("/accounts/suggestions");
}

export async function acceptAccountSuggestion(
  id: string,
  payload: CreateAccountRequest,
): Promise<AccountItem> {
  return request<AccountItem>(`/accounts/suggestions/${id}/accept`, {
    method: "POST",
    data: payload,
  });
}

export async function dismissAccountSuggestion(
  id: string,
  never: boolean,
): Promise<void> {
  await request<void>(`/accounts/suggestions/${id}/dismiss`, {
    method: "POST",
    data: { never },
  });
}

export async function fetchNetWorth(year: number): Promise<NetWorthResponse> {
  return request<NetWorthResponse>(`/accounts/net-worth?year=${year}`);
}

export async function repairGrabAccounts(): Promise<{
  receipts: number;
  updated: number;
  unassigned: number;
}> {
  return request("/gmail-integration/repair-grab-accounts", {
    method: "POST",
  });
}
